import { FeatureFlagKey } from "encamp-shared/src/featureFlags";

import { useStaffPreviewingFlag } from "../../hooks/useStaffPreviewingFlag";
import { type PreviewVariant } from "./constants";
import { PreviewFeatureIndicator } from "./PreviewFeatureIndicator";

type StaffInDevelopmentIconProps = {
  flag: FeatureFlagKey;
  fontSize?: number | string;
  inline?: boolean;
  /** Nav context passes the same color as the adjacent nav icon. */
  color?: string;
  /** `newVersion` when an existing experience is still available behind the preview. */
  variant?: PreviewVariant;
};

/**
 * Renders the in-development Handyman icon when a staff user is previewing a
 * feature that is not yet enabled for the current tenant. Place inline next to
 * section titles, tile headers, etc. — use {@link PreviewFeatureScope} for
 * route-level breadcrumb preview instead.
 */
export function StaffInDevelopmentIcon({
  flag,
  fontSize,
  inline,
  color,
  variant,
}: StaffInDevelopmentIconProps) {
  const isPreview = useStaffPreviewingFlag(flag);

  if (!isPreview) {
    return null;
  }

  return (
    <PreviewFeatureIndicator fontSize={fontSize} inline={inline} color={color} variant={variant} />
  );
}
